export default __webpack_public_path__ + "static/media/uis-guangzhou.67975b7c.png";